import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { LetterContentEditor } from 'assets/js/pages/engage/letters/LetterContentEditor';
import { PersonalizedAlertNotification } from 'assets/js/pages/engage/letters/PersonalizedAlertNotification';
import { useLetterMeta } from 'assets/js/pages/engage/letters/useLetterMeta';
import { twMerge } from 'tailwind-merge';

const LetterCompose = () => {
    const { isEasySend } = useLetterMeta();
    return (
        <div className={'flex gap-4 px-6'}>
            <div className={'hidden flex-1 md:block'} />
            <div className={'md:flex-2 mx-auto md:min-w-[768px]'}>
                <div className={'flex flex-col gap-4'}>
                    <PersonalizedAlertNotification />
                    <LetterContentEditor />
                </div>
            </div>
            <div className={twMerge('hidden flex-1 md:block', !isEasySend && 'invisible')}>
                <div className="float-left flex max-w-xs flex-col gap-2 rounded-xl bg-gray-100 p-4">
                    <div>
                        <FontAwesomeIcon icon={faInfoCircle} className="text-violet-500" />
                    </div>
                    <div className="flex flex-col gap-6">
                        <div>
                            <div className="text-sm font-medium">
                                Can I direct recipients to donate?
                            </div>
                            <div className="text-xs text-gray-600">
                                Create and insert a QR code from the letter tool bar. Recipients can
                                scan the code to be taken straight to a donation form, allowing you
                                to track the success of your letter.
                            </div>
                        </div>
                        <div>
                            <div className="text-sm font-medium">Needing more personalization?</div>
                            <div className="text-xs text-gray-600">
                                Once you've added mailing recipients, you can personalize any
                                contact's letter, allowing you to tailor the copy to each supporter
                                individually!
                            </div>
                        </div>
                        <div>
                            <div className="text-sm font-medium">Where do the addresses go?</div>
                            <div className="text-xs text-gray-600">
                                Each recipient's name and address occupies the first third of the
                                first page of your letter before folding.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export { LetterCompose };
